module.exports = __webpack_public_path__ + "img/oulabi-white.fa309c32.png";